/* LaBelle free-gift picker v2: orders >= $100 choose a free Hat or Cardholder.
   Pairs with automatic discount "Free Gift Over $100 (Hat or Cardholder)". */
(function () {
  var GIFTS = [
    { variant: 42668285493322, name: 'Hat',
      img: 'https://cdn.shopify.com/s/files/1/0611/4816/8266/files/Screenshot_2025-12-10_at_1.42.18_PM.png?v=1765392573&width=200' },
    { variant: 42169134284874, name: 'Cardholder',
      img: 'https://cdn.shopify.com/s/files/1/0611/4816/8266/files/labelle-cardholder-silver.png?width=200' }
  ];
  var THRESHOLD = 10000; /* cents */
  var busy = false;

  function isGiftVariant(i) { return GIFTS.some(function (g) { return g.variant === i.variant_id; }); }
  function isOurGift(i) { return isGiftVariant(i) && i.properties && i.properties._gift; }

  function fmt(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function boxHTML(subtotal, gifted) {
    var pct = Math.min(100, Math.round(subtotal / THRESHOLD * 100));
    var html = '<div class="lbt-gift-bar"><span class="lbt-gift-fill' + (pct >= 100 ? ' is-full' : '') + '" style="width:' + pct + '%"></span></div>';
    if (gifted) {
      html += '<p class="lbt-gift-title lbt-gift-done">Free gift added. Orders over $100 get one free.</p>';
    } else if (subtotal >= THRESHOLD) {
      html += '<p class="lbt-gift-title">Orders over <strong>$100</strong> get a free gift. Pick yours:</p>' +
        '<div class="lbt-gift-btns">' +
        GIFTS.map(function (g) {
          return '<button type="button" class="lbt-gift-btn" data-variant="' + g.variant + '">' +
            '<span class="lbt-gift-thumb" style="background-image:url(' + g.img + ')"></span>' +
            '<span class="lbt-gift-name">' + g.name + '</span>' +
            '<span class="lbt-gift-free">FREE</span>' +
          '</button>';
        }).join('') +
        '</div>';
    } else {
      html += '<p class="lbt-gift-title">Orders over <strong>$100</strong> get a free gift. Add <strong>' + fmt(THRESHOLD - subtotal) + '</strong> to unlock yours.</p>';
    }
    return html;
  }

  function check() {
    if (busy) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var ourGift = null, subtotal = 0;
      cart.items.forEach(function (i) {
        if (isOurGift(i)) { ourGift = i; } else { subtotal += i.final_line_price; }
      });
      var qualifies = subtotal >= THRESHOLD;
      if (ourGift && !qualifies) { removeLine(ourGift.key); return; }
      if (cart.items.length === 0) {
        document.querySelectorAll('.lbt-gift-box').forEach(function (b) { b.remove(); });
        return;
      }
      var html = boxHTML(subtotal, !!ourGift);
      var anchors = document.querySelectorAll(
        'cart-drawer .drawer__footer, .cart__footer, cart-notification .cart-notification__links'
      );
      anchors.forEach(function (anchor) {
        var box = anchor.querySelector('.lbt-gift-box');
        if (!box) {
          box = document.createElement('div');
          box.className = 'lbt-gift-box';
          anchor.insertBefore(box, anchor.firstChild);
        }
        if (box.getAttribute('data-state') === html) return;
        box.setAttribute('data-state', html);
        box.innerHTML = html;
        box.querySelectorAll('.lbt-gift-btn').forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.preventDefault();
            addGift(parseInt(b.getAttribute('data-variant'), 10), box, b);
          });
        });
      });
    }).catch(function () {});
  }

  function refreshCartUI() {
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        Object.keys(sections).forEach(function (key) {
          if (!sections[key]) return;
          var target = document.getElementById('shopify-section-' + key) ||
                       document.querySelector('[id^="shopify-section"][id*="' + key + '"]');
          if (target) {
            var doc = new DOMParser().parseFromString(sections[key], 'text/html');
            var fresh = doc.getElementById('shopify-section-' + key) || doc.body.firstElementChild;
            if (fresh) target.innerHTML = fresh.innerHTML;
          }
        });
        busy = false;
        setTimeout(check, 150);
      })
      .catch(function () { busy = false; window.location.reload(); });
  }

  function addGift(variantId, box, btn) {
    if (busy) return; busy = true;
    if (btn) btn.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _gift: '1' } })
    }).then(function () {
      if (box) box.innerHTML = '<p class="lbt-gift-title lbt-gift-done">Free gift added. Orders over $100 get one free.</p>';
      refreshCartUI();
    }).catch(function () { busy = false; });
  }

  function removeLine(key) {
    if (busy) return; busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { refreshCartUI(); }).catch(function () { busy = false; });
  }

  document.addEventListener('DOMContentLoaded', check);
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-icon-bubble, [href="/cart"], cart-remove-button, .quantity__button, button[name="add"]')) {
      setTimeout(check, 900);
    }
  });
  /* The watch is a plain full-payment preorder; AMP attaches a selling plan that
     blocks automatic discounts (free gift) and adds "deferred purchase" checkout
     text. Strip selling_plan from watch add-to-cart calls. */
  var WATCH_VARIANTS = [43835576123466, 43835576156234];
  var PREORDER_KEY = 'Preorder';
  var PREORDER_VAL = 'Expected delivery Dec 16';
  function isWatch(id) { return WATCH_VARIANTS.indexOf(parseInt(id, 10)) > -1; }
  function stripPlan(body) {
    try {
      if (typeof body === 'string' && body.trim().charAt(0) === '{') {
        var data = JSON.parse(body);
        var fix = function (o) {
          if (!o || !isWatch(o.id)) return;
          if (o.selling_plan) delete o.selling_plan;      /* keep watch a plain line so free gift applies */
          o.properties = o.properties || {};
          if (!o.properties[PREORDER_KEY]) o.properties[PREORDER_KEY] = PREORDER_VAL;  /* shows on cart + checkout line */
        };
        if (data.items && data.items.forEach) data.items.forEach(fix); else fix(data);
        return JSON.stringify(data);
      }
      if (typeof body === 'string') {
        var sp = new URLSearchParams(body);
        if (isWatch(sp.get('id'))) {
          sp.delete('selling_plan');
          if (!sp.has('properties[' + PREORDER_KEY + ']')) sp.set('properties[' + PREORDER_KEY + ']', PREORDER_VAL);
          return sp.toString();
        }
        return body;
      }
      if (body instanceof FormData) {
        if (isWatch(body.get('id'))) {
          body.delete('selling_plan');
          if (!body.has('properties[' + PREORDER_KEY + ']')) body.set('properties[' + PREORDER_KEY + ']', PREORDER_VAL);
        }
        return body;
      }
    } catch (e) {}
    return body;
  }
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = input && (input.url || input);
    if (typeof url === 'string' && /\/cart\/add/.test(url) && init && init.body) {
      init.body = stripPlan(init.body);
    }
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update)/.test(url)) {
      p.then(function () { setTimeout(check, 500); });
    }
    return p;
  };
  /* also cover form-POST adds (non-fetch) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && /\/cart\/add/.test(form.action || '')) {
      var idEl = form.querySelector('[name="id"]');
      if (idEl && isWatch(idEl.value)) {
        var sel = form.querySelector('[name="selling_plan"]');
        if (sel) sel.remove();
        if (!form.querySelector('[name="properties[' + PREORDER_KEY + ']"]')) {
          var h = document.createElement('input');
          h.type = 'hidden'; h.name = 'properties[' + PREORDER_KEY + ']'; h.value = PREORDER_VAL;
          form.appendChild(h);
        }
      }
    }
  }, true);
})();
